// extracted by mini-css-extract-plugin
export default {"footer":"_1LCdEXo6Ou","language":"_17VCKwZqgH","language-dropdown":"_1ouroK5kZG","languageDropdown":"_1ouroK5kZG","transparent":"_1mzxbW4Qxa","footer-section":"gk5q2nltky","footerSection":"gk5q2nltky","interactive":"_2zbQcsQYVF","right":"_21Lf9ro8LR","link":"VRYMcnisEk","copyright-links":"_1qU8Mzzxxk","copyrightLinks":"_1qU8Mzzxxk","left":"_3RbwVmKqMO","footer-section-button":"_22A7eaJ63L","footerSectionButton":"_22A7eaJ63L","primary":"_2NeEyfN5TD"};
    if(module.hot) {
      // 1628247831251
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  